import { useId } from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { DEACTIVATION_REASONS, DeactivationReason } from '@constants/deactivation';

export type DeactivationReasonSelectProps = {
  value: DeactivationReason | '';
  onChange: (reason: DeactivationReason) => void;
};

/**
 * Required picker shared by every deactivation modal (GLX-1424). Callers hold
 * `''` until an operator picks, and gate their confirm button on it.
 */
export const DeactivationReasonSelect = ({ value, onChange }: DeactivationReasonSelectProps) => {
  const labelId = useId();

  return (
    <FormControl fullWidth required>
      <InputLabel id={labelId}>Reason for Deactivation</InputLabel>
      <Select<DeactivationReason | ''>
        labelId={labelId}
        label="Reason for Deactivation"
        value={value}
        onChange={(e) => {
          // Narrows away the '' the caller holds before a pick; MUI itself only
          // emits values matching a MenuItem.
          const next = e.target.value;
          if (!next) {
            return;
          }
          onChange(next);
        }}
      >
        {DEACTIVATION_REASONS.map((reason) => (
          <MenuItem key={reason} value={reason}>
            {reason}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default DeactivationReasonSelect;
